import request from '@/utils/request.ts'

export const getArticles = (params: any) =>
  request({
    url: '/articles',
    method: 'get',
    params
  })
